import React from 'react'
import {ProjectViewConfig} from "../../../../../../../../../core/model2/project-view/@types";

type Props = {
    onBack      : callback
    className?      : string
}

export default function AddView_SelectView(props: Props) {

    return (
        <div className="back-link ui5-link-icon-default" onClick={props.onBack}>
            <div className="icon s-15 i5-long-arrow-left m-r-8 h-20"/>
            <div className="ui5-link-small">Select view</div>
        </div>

    )

}
